import React from 'react';
import cn from 'classnames';

import type { TDesktop } from '../../models/desktop';
import type { TMobile } from '../../models/mobile';

/**
 * Функция отображения преимуществ в основной версии баннера
 * @param props пропс виджета
 */
export function bannerBenefits(props: TMobile | TDesktop) {
    const { Benefits, analytics, benefits, onEventPublish, styles, theme } = props;

    return (
        <Benefits
            analytics={analytics}
            benefits={benefits}
            className={cn(styles.external, styles.benefits)}
            dataTestId="mainBannerBenefits"
            onEventPublish={onEventPublish}
            theme={theme}
        />
    );
}
